import { ContactMetadata } from 'commons/types/DTO/bank'

export interface ContactMetadataFormValue extends ContactMetadata {
  permissions: string[]
}
